module.exports = __webpack_public_path__ + "img/cashier_advantage_2.a0ff8853.png";